import React, { useState, useEffect, useContext } from 'react'
import './style.scss'
import { useQuery } from '@tanstack/react-query';
import { ToastContainer, toast } from 'react-toastify'
//import 'react-toastify/dist/ReactToastify.css'
import Icon from 'react-icons-kit'
import { edit2, } from 'react-icons-kit/feather'//eye 
// import { heart } from 'react-icons-kit/icomoon'
import { Images } from '../../../utils/Images'
import Requests from '../../../utils/Requests/Index'
import ImageCrop from '../../../components/Form/Picture'
import ProfileCard from '../../../components/Dashboard/ProfileCard'
import ProfileCard2 from "../../../components/Profile/Index"
import ProfileSlider from '../../../components/ProfileSlider/Index'
import Loading from '../../../components/Loading/Index'
import { useLocation,  } from 'react-router-dom' //useNavigate
import { singleProContext } from '../../../utils/context/SingleProfileContext'

//toast.configure({ autoClose: 2000 })


const Index = () => {
    let { search } = useLocation()
    // let histroy = useNavigate()
    const { handleLocalStoreIds } = useContext(singleProContext);
    const [show, setShow] = useState(false)
    const [header] = useState({ headers: { Authorization: "Bearer " + localStorage.getItem('token') } })
    let [pageLoad, setPageload] = useState(true)

    // Fetch data
    const getDashboardData = async () => {
        try {
            const data = await Requests.Dashboard.Index(header)
            if (data && data.user) {
                setPageload(false)
            }
            return data.user
        } catch (error) {
            // toast.error(error.message)
            console.log(error.message)
        }
    }

    // const { data, isLoading, isError } = useQuery("dashboard", getDashboardData, {
    //     retry: false,
    //     cacheTime: 1200000,
    //     refetchOnWindowFocus: false,
    //     enabled: Boolean(pageLoad)
    // })
    const { data, isLoading, isError } = useQuery({
    queryKey: ["dashboard"],
    queryFn: getDashboardData,
    retry: false,
    cacheTime: 1200000,
    refetchOnWindowFocus: false,
    enabled: Boolean(pageLoad),
    })
    //after payment
    useEffect(() => {
        if (search.split('=')[1] === "success") {
            toast.success('Congratulations,Payment Successful')
        }
        else if (search.split('=')[1] === 'failed') {
            toast.error('Payment is not Successful, try again')
        }
        else if (search.split('=')[1] === 'cancle') {
            toast.error('Payment cancled, try again')
        }
    }, [search])

    useEffect(() => {
        // Set ids For Single Profile...
        let recentViewIds = []
        let matchIds = []
        if (data?.recentViewed) {
            recentViewIds = data?.recentViewed?.map(info => info._id);
        }
        if (data?.matches) {
            matchIds = data?.matches?.map(info => info._id);
        }
        handleLocalStoreIds([...recentViewIds, ...matchIds]);
    }, [data]); // eslint-disable-line react-hooks/exhaustive-deps

    // const toPackage = e => {
    //     e.preventDefault()
    //     histroy.push('/my-metrimony/package')
    // }

    if (isLoading || isError) return <Loading />

    // console.log(data?.recentViewed)

    return (
        <>
        <ToastContainer position="top-right" autoClose={3000} /> 
        {isLoading ||isError || data === undefined?
        <div className="dashboard">
            {isLoading &&  <Loading />}
        </div>:
        <div className="dashboard">
            {/* Profile container */}
            <div className="profile-container">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="d-lg-flex">

                                <div className="card flex-fill border-0 px-lg-4 mb-4 mb-xl-0 activity-card">

                                    <div className="px-0">

                                        <div className='pb-4'>
                                            <div className="card-header border-0 ">
                                                <h5>Profile Info</h5>
                                            </div>
                                            <div className='card-body profile-section row'>
                                                <div className="col-md-4 img-container">
                                                    <img src={data.image ? data.image : Images.NoImage} className="img-fluid" alt="..." />
                                                    <button type="button" className="btn shadow rounded-circle" onClick={() => setShow(true)}>
                                                        <Icon icon={edit2} size={18} />
                                                    </button>
                                                </div>
                                                <div className='info-container col-md-8'>
                                                    <h6 className="text-uppercase">{data.name}</h6>
                                                    <p>ID: {data.profileId}</p>
                                                    <hr />
                                                    <div className='row'>
                                                        <div className='col-lg-6'>
                                                            <h6>Account Type :{data.profileType} Membership</h6>
                                                            <h6>Proposal limit : {data.packageInfo?.totalLimit}</h6>
                                                        </div>
                                                        <div className='col-lg-6'>
                                                            <h6>Contact view: {data.profileType}</h6>
                                                            <h6>Expire Date     : {data.profileType}</h6>
                                                        </div>
                                                    </div>
                                                    <hr className='m-0' />
                                                    <div className="">
                                                        <h6>Mobile Verification :{data.isPhoneVerified ?
                                                            <span className="text-success">Verified number</span> :
                                                            <span className="text-warning">Unverified number</span>
                                                        }</h6>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="activity-summary-header border-0 text-left">
                                            <h4 className='p-2 border-0'>Activity Summary</h4>
                                        </div>
                                        <div className=" row">
                                            <div className="col-lg-3 col-md-6 card_area ">
                                                <img src={Images.connetction} alt="..." className='' />
                                                <div className='content'>
                                                    <h6>Connection</h6>
                                                    <span>{data.connection}</span>
                                                </div>
                                            </div>
                                            <div className="col-lg-3 col-md-6 card_area">

                                                <img src={Images.favourite} alt="..." className='' />

                                                <div className='content '>
                                                    <h6>Favourite</h6>
                                                    <span>{data.favorite}</span>
                                                </div>

                                            </div>

                                            <div className="col-lg-3 col-md-6 card_area">
                                                <img src={Images.pending} alt="..." className='' />

                                                <div className='content '>
                                                    <h6>Pending </h6>
                                                    <span>{data.pendingRequest}</span>
                                                </div>

                                            </div>

                                            <div className="col-lg-3 col-md-6 card_area">
                                                <img src={Images.sentRequest} alt="..." className='' />
                                                <div className='content '>
                                                    <h6>Sent </h6>
                                                    <span>{data.sentRequest}</span>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="px-3 text-center">
                                            <div className="progress shadow mt-4 mt-lg-5">
                                                <div className="progress-bar" role="progressbar" style={{ width: data.updateRange + "%" }} aria-valuenow="45" aria-valuemin="0" aria-valuemax="100">{data.updateRange}%</div>
                                            </div>
                                            <p>Profile improve steps ( ex: contact details, id card information)</p>
                                        </div>

                                    </div>
                                </div>

                                {/* Add card */}
                                <div className="card d-none d-xl-block border-0 add-card">
                                    <img src={data?.addsense ? data.addsense : Images.WebAdd} className="img-fluid" alt="Add sense" />
                                </div>

                            </div>
                        </div>
                    </div>

                </div>
            </div>

            {/* Matches container */}
            <div className="matches-container">
                <div className="container">

                    {/* My Matches */}
                    <div className="row">
                        <div className="col-12 mb-5 mb-xl-0 ">
                            <h5 className="matches-title text-center text-xl-left mb-3">My Matches</h5>
                        </div>
                    </div>

                    <div className="d-block d-md-none">
                        {data && data.matches && data.matches.length ? data.matches.map((item, i) =>
                            <ProfileCard2 item={item} key={i} />
                        ) : null}
                    </div>

                    <div className="d-none d-md-block">
                        <div className="row">
                            {data && data.matches && data.matches.length ? data.matches.map((item, i) =>
                                <div className="col-12 col-lg-6 mb-5 mb-xl-0" key={i}>
                                    <ProfileCard item={item} />
                                </div>
                            ) : null}
                        </div>
                    </div>


                    {/* Viewed container */}
                    <div className="visitors-container my-5">
                        <div className="row">
                            <div className="col-12 mb-5 mb-xl-0 ">
                                <h5 className="matches-title text-center text-xl-left mb-3">Recent Visit</h5>
                            </div>
                        </div>

                        <div className="">
                            {data && data.recentViewed && data.recentViewed.length ?
                                <ProfileSlider items={data.recentViewed} setPageload={setPageload} />
                                : <div className='text-center'>no such user viewed your profile yet</div>
                            }

                        </div>
                    </div>


                    {/* New Matches */}
                    {/* <div className="col-12 col-lg-6">
                            <h5 className="text-center text-xl-left mb-4">New Matches</h5>

                            {result && result.length ? result.map((item, i) =>
                                <ProfileCard item={item} key={i} />
                            ) : null}
                        </div> */}


                </div>
            </div>
            {show ? <ImageCrop show={show} onHide={() => setShow(false)} image={data.image ? data.image : null} setPageload={setPageload} /> : null}
        </div>}
        </>
    );
};

export default Index;